export default __webpack_public_path__ + "static/examp2-ff65556426f3d5bea77d68ea97325be6.gif";